import { homeRouterMap } from '@/config/router.config'
import config from '@/config/defaultSettings'

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function formatDate (timestamp) {
  var date = new Date(timestamp)
  return date.getUTCFullYear() + ' 年 ' + date.getMonth() + ' 月 ' + date.getDate() + '日'
}

export function debounce (func, wait, immediate) {
  var timeout
  return function () {
    var context = this; var args = arguments
    var later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
};

export function isInHomeRouters (path) {
  return hasPath(homeRouterMap, path)
  function hasPath (routers, path) {
    for (let i = 0; i < routers.length; i++) {
      if (routers[i].path == path) return true
      var childRouters = routers[i].children
      if (childRouters && childRouters.length != 0) {
        if (hasPath(childRouters, path)) return true
      }
    }

    return false
  }
}

export function toFlatLabellist (labelTrees) {
  var temp = []
  labelTrees.map(item => {
    temp.push({
      key: item.value,
      value: item.label,
      label_id: item.label_id
    })
    if (item.children.length != 0) temp = temp.concat(toFlatLabellist(item.children))
  })
  return temp
}

export function loadLabelTree (resData) {
  var option = new Array()
  resData.map(item => {
    option.push({
      value: item.label_value, // 00000100
      label: item.label_name, // 异常
      label_id: item.label_id, // 138
      children: loadLabelTree(item.children)
    })
  })
  return option
}

export function initNoticeSocket (token, updateMessage) {
  const socket = new WebSocket(config.webSocketUrl)
  const update = updateMessage
  socket.onopen = (e) => {
    socket.send(token)
  }
  socket.onmessage = (res) => {
    if (/type/.test(res.data) == false) return
    update(JSON.parse(res.data))
  }
  window.unload = function (e) {
    socket.close()
  }
  return socket
}
